import { __decorate, __extends } from "tslib";
import { PROPS_LIST, proxyTo, serialisable } from '../utils/FilterUtils';
import { BlurFilter } from './BlurFilter';
import { DropShadowTask } from './tasks/webgl/DropShadowTask';
import { FilterBase } from './FilterBase';
var DropShadowFilter = /** @class */ (function (_super) {
    __extends(DropShadowFilter, _super);
    function DropShadowFilter(options) {
        var _this = _super.call(this) || this;
        _this._shadowTask = new DropShadowTask();
        _this.distance = 0;
        _this.angle = 0;
        _this.color = 0x0;
        _this.alpha = 1;
        _this.strength = 1;
        _this.inner = false;
        _this.knockout = false;
        _this.hideObject = false;
        _this.imageScale = 1;
        _this._blurFilter = new BlurFilter(options);
        _this.addTask(_this._shadowTask);
        _this.applyProps(options);
        return _this;
    }
    DropShadowFilter.prototype.applyProps = function (model) {
        if (!model)
            return;
        // run all model field that changed
        for (var _i = 0, _a = this[PROPS_LIST]; _i < _a.length; _i++) {
            var key = _a[_i];
            if (key in model) {
                this[key] = model[key];
            }
        }
        if (model.filterName === DropShadowFilter.filterNameAlt) {
            this.angle = 0;
            this.distance = 0;
        }
        this._blurFilter.applyProps(model);
    };
    DropShadowFilter.prototype.meashurePad = function (input, target) {
        if (target === void 0) { target = input; }
        target = this._blurFilter.meashurePad(input, target);
        var offsetX = 0;
        var offsetY = 0;
        // for outer or both need render a drop shadow with valid pad
        var dist = Math.abs(this.distance);
        if (!this.inner && dist > 0) {
            var rad = this.angle * Math.PI / 180;
            offsetX += Math.cos(rad) * dist * 2;
            offsetY += Math.sin(rad) * dist * 2;
        }
        target.x -= offsetX;
        target.y -= offsetY;
        target.width += offsetX * 2;
        target.height += offsetY * 2;
        return target;
    };
    DropShadowFilter.prototype.apply = function (source, target, sourceRect, destRect, filterManager, clearOutput) {
        if (clearOutput === void 0) { clearOutput = false; }
        var tmp = filterManager.popTemp(source.width, source.height);
        this._blurFilter.apply(source, tmp, sourceRect, tmp.rect, filterManager, true);
        this._shadowTask.sourceImage = source;
        _super.prototype.apply.call(this, tmp, target, sourceRect, destRect, filterManager, clearOutput);
        filterManager.pushTemp(tmp);
    };
    DropShadowFilter.prototype.setRenderState = function (source, target, sourceRect, outRect, filterManager) {
        _super.prototype.setRenderState.call(this, source, target, sourceRect, outRect, filterManager);
        this._shadowTask.inputRect.copyFrom(sourceRect);
        this._shadowTask.destRect.copyFrom(outRect);
        this._shadowTask.source = source;
        this._shadowTask.target = target;
    };
    DropShadowFilter.filterName = 'dropShadow';
    DropShadowFilter.filterNameAlt = 'glow';
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "distance", void 0);
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "angle", void 0);
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "color", void 0);
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "alpha", void 0);
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "strength", void 0);
    __decorate([
        serialisable
    ], DropShadowFilter.prototype, "quality", void 0);
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "inner", void 0);
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "knockout", void 0);
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "hideObject", void 0);
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "imageScale", void 0);
    return DropShadowFilter;
}(FilterBase));
export { DropShadowFilter };
